module.exports = __webpack_public_path__ + "img/add_bg_img.578a6a98.svg";